@if(this.formTabs && this.formTabs.length>0){
<div class="d-flex justify-content-between mb-2 align-items-center flex-wrap">
  <div class="d-flex align-items-center p-2 filter">
    <span class="me-2">
      {{ "case.inspectation-informations.filter-text" | translate }}
    </span>
    <input
      class="form-check-input"
      style="margin-left: 5%"
      [(ngModel)]="showAnswered"
      (ngModelChange)="filterArray()"
      type="checkbox"
      role="switch"
      aria-checked="true"
    />
  </div>

  <div class="d-flex align-items-center p-2 filter">
    <span class="me-2">
      {{ "common.search-label" | translate }}
    </span>
    <div class="search-container position-relative">
      <input
        type="text"
        [placeholder]="'common.search' | translate"
        [(ngModel)]="searchText"
        (ngModelChange)="filterArray()"
        class="form-control pe-4"
      />
      <i
        class="fa fa-search position-absolute"
        style="right: 10px; top: 50%; transform: translateY(-50%)"
      ></i>
    </div>
  </div>
</div>

<hr />

<div class="hospital-form-container">
  <div class="form-tabs">
    <div style="height: fit-content; max-height: 100%; overflow-y: auto">
      <div class="tab-navigation">
        <button
          *ngFor="let tab of formTabs; let i = index"
          class="tab-button"
          [class.active]="activeTabIndex === i && !selectedCommonTab"
          [class]="tab?.isTabCompleted ? 'completed' : 'not-completed'"
          (click)="setActiveTab(i)"
        >
          <div class="tab-info">
            <span class="tab-title">{{ tab?.title }}</span>
            <span class="tab-description">{{ tab?.description }}</span>
          </div>
          <div class="tab-status">
            @if(tab?.isTabCompleted){
            <div class="completed-icon">✓</div>
            }@else{
            <div class="error-icon">!</div>
            }
          </div>
        </button>
      </div>

      <!-- sabit butonlar -->
      <div class="tab-navigation mt-2">
        <button
          *ngFor="let tab of commonTabs; let i = index"
          [class.active]="clickedCommonTabIndex === i"
          class="tab-button completed"
          (click)="commonTabClick(i)"
        >
          <div class="tab-info">
            <span class="tab-title">{{ tab?.title | translate }}</span>
            <span class="tab-description">{{ tab?.description }}</span>
          </div>
        </button>
      </div>
    </div>

    <div class="tab-content">
      @if(selectedCommonTab){
      <div class="active-tab">
        <div class="tab-header">
          <h2 class="tab-title">{{ selectedCommonTab?.title | translate }}</h2>
          <p *ngIf="selectedCommonTab?.description" class="tab-description">
            {{ selectedCommonTab?.description }}
          </p>
        </div>
        @switch (clickedCommonTabIndex) { @case (0) {
        <div class="list-container">
          <div *ngFor="let item of diagnoses">
            <div *ngIf="item.savedType === 'ambulance'" class="list-item">
              <div class="item-content">
                <div class="main-info">
                  <h3 class="name">{{ item?.icdCodeName }}</h3>
                  <span class="type-badge">
                    @if(item?.savedType==='user'){
                    <i class="fa-solid fa-user"></i>
                    }@else if(item?.savedType==='ambulance'){
                    <i class="fa-solid fa-truck-medical"></i>
                    }
                  </span>

                  <span class="code">{{ item?.icdCode }}</span>
                </div>

                <p class="description">{{ item?.description }}</p>
              </div>
            </div>
          </div>
        </div>

        } @case (1) {
        <div class="list-container">
          <div *ngFor="let item of vitalSigns" class="list-item">
            <div class="item-content">
              <div class="main-info">
                <h3 class="parameter-name">{{ item?.parameter?.label }}</h3>
              </div>

              <div class="inputs-section">
                <div class="input-group" *ngIf="item?.input1">
                  <span class="input-label">Input 1:</span>
                  <span class="input-value"
                    >{{ item?.input1 }} {{ item?.unit }}</span
                  >
                </div>
                <div class="input-group" *ngIf="item?.input2">
                  <span class="input-label">Input 2:</span>
                  <span class="input-value"
                    >{{ item?.input2 }} {{ item?.unit }}</span
                  >
                </div>
              </div>

              <div class="description-section" *ngIf="item?.description">
                <p class="description">{{ item?.description }}</p>
              </div>

              <div class="meta-info">
                <span class="input-count">{{ item?.numberOfInput }} Input</span>
              </div>
            </div>
          </div>
        </div>
        } @default { } }
      </div>

      }@else{
      <div *ngIf="activeTab" class="active-tab">
        <div class="tab-header">
          <h2 class="tab-title">{{ activeTab.title }}</h2>
          <p *ngIf="activeTab.description" class="tab-description">
            {{ activeTab.description }}
          </p>
        </div>

        <div class="form-fields" *ngIf="activeTab?.filteredFormTabItems">
          <app-case-form-questions-inputs
            *ngFor="let item of activeTab.filteredFormTabItems"
            [item]="item"
            (valueChange)="onAnswerChange(activeTab.id!, item.id, $event)"
          ></app-case-form-questions-inputs>
        </div>
      </div>
      }
    </div>
  </div>
  <div
    class="form-actions"
    *ngIf="!selectedCommonTab && !(isReadOnly || isCaseApproved)"
  >
    <button
      class="btn btn-secondary"
      [disabled]="activeTabIndex === 0"
      (click)="previousTab()"
    >
      {{ "case.inspectation-informations.before" | translate }}
    </button>

    <div class="progress-info">
      <span class="progress-text">
        {{ activeTabIndex + 1 }} / {{ formTabs.length }}
      </span>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="((activeTabIndex + 1) / formTabs.length) * 100"
        ></div>
      </div>
    </div>

    <button
      *ngIf="activeTabIndex < formTabs.length - 1"
      class="btn btn-primary"
      (click)="nextTab()"
    >
      {{ "case.inspectation-informations.next" | translate }}
    </button>

    <button
      *ngIf="activeTabIndex === formTabs.length - 1 || canSendForm"
      class="btn btn-success"
      (click)="sendSubmit()"
    >
      {{ "case.inspectation-informations.send-form" | translate }}
    </button>
  </div>
</div>
}@else if(!loading){
<div class="container">
  <div class="card">
    <div class="icon-container">
      <div class="icon">
        <svg viewBox="0 0 24 24">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
          />
        </svg>
      </div>
    </div>

    <h1 class="title">
      {{ "case.inspectation-informations.no-form" | translate }}
    </h1>
    <p class="subtitle">
      {{ "case.inspectation-informations.no-form-title" | translate }}
    </p>

    <p class="help-text">
      {{ "case.inspectation-informations.no-form-muted-text" | translate }}
    </p>
  </div>
</div>
}

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
<app-case-documents
  (closeOn)="onDocumentClose()"
  #caseDocument
></app-case-documents>
